import React from 'react';
import { Card } from 'antd';

const StatisticCard = ({ stat }) => {
  return (
    <Card
      hoverable
      className="h-full transition-all duration-300 hover:shadow-lg"
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-start mb-4">
          <div className="flex flex-col">
            <span className="text-2xl font-bold text-neutral-800">
              {stat.value}
            </span>
            <span className="text-sm text-neutral-500 mt-1">
              {stat.title}
            </span>
          </div>
          <div className={`bg-${stat.color}-50 p-3 rounded-xl`}>
            <span className={`text-xl text-${stat.color}-500`}>
              {stat.icon}
            </span>
          </div>
        </div>
        <div className="mt-auto pt-4 border-t border-neutral-100">
          <span className={`text-${stat.color}-500 text-sm font-medium`}>
            {stat.growth}
          </span>
          <span className="text-xs text-neutral-400 ml-2">
            vs {stat.previousValue} précédemment
          </span>
        </div>
      </div>
    </Card>
  );
};

export default StatisticCard; 